export default {
    send: 'Always send',
    dontSend: "Don't send if closed",
    nextOpen: 'Execute at next open hour',
    weekdays: 'Only these days',
};
